module.exports = __webpack_public_path__ + "img/tarjeta_proximidad.f7da40c2.png";